{{#if allInstanceVariablesWithFieldMacro.length}}
`uvm_object_{{#if useParamUtils}}param_{{/if}}utils_begin({{ thisType }})
  {{> (partial "snippets/uvm-object-field-macros")}}
`uvm_object_utils_end
{{else}}
`uvm_object_{{#if useParamUtils}}param_{{/if}}utils({{ thisType }})
{{/if}}
